import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({ clienti: [], stabilimenti: [], contatti: [], tecnici: [], tickets: [], divisioni: [] });

  const loadMe = async () => {
    try {
      const me = await api.get("/auth/me");
      setUser(me);
      return me;
    } catch { setUser(null); return null; }
  };

  useEffect(() => {
    const handler = (e) => {
      const detail = e.detail || {};
      if (detail.user) setUser(detail.user);
      else if (detail.expires_at) setUser(u => u ? { ...u, expires_at: detail.expires_at } : u);
    };
    window.addEventListener("emmepi:session-refreshed", handler);
    return () => window.removeEventListener("emmepi:session-refreshed", handler);
  }, []);

  const loadData = async () => {
    if (!user) return;
    try {
      const [clienti, stabilimenti, contatti, tecnici, tickets, divisioni] = await Promise.all([
        api.get("/clienti"), api.get("/stabilimenti"), api.get("/contatti"),
        api.get("/tecnici"), api.get("/tickets"), api.get("/divisioni"),
      ]);
      setData({ clienti, stabilimenti, contatti, tecnici, tickets, divisioni });
    } catch (e) { /* ignore, might be pwd change required */ }
  };

  useEffect(() => { loadMe().finally(() => setLoading(false)); }, []);
  useEffect(() => { if (user && !user.must_change_password) loadData(); }, [user]);

  const login = async (username, password) => {
    const r = await api.post("/auth/login", { username, password });
    setUser(r.user);
    return r;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    setUser(null);
    setData({ clienti: [], stabilimenti: [], contatti: [], tecnici: [], tickets: [], divisioni: [] });
  };
  const changePassword = async (current_password, new_password) => {
    const u = await api.post("/auth/change-password", { current_password, new_password });
    setUser(u);
    return u;
  };

  const canEdit = () => user?.role === "OWNER" || user?.role === "SERVICE_MANAGER";
  const canClose = () => user?.role === "OWNER" || user?.role === "SERVICE_MANAGER";
  const isOwner = () => user?.role === "OWNER";
  const isViewer = () => user?.role === "VIEWER";

  return (
    <AuthCtx.Provider value={{
      user, loading, login, logout, changePassword,
      data, reload: loadData,
      canEdit, canClose, isOwner, isViewer,
      // legacy compatibility
      profile: user ? { nome: user.nome, ruolo: user.role, perm: user.role } : null,
      isTecnico: () => false,
      myTecnicoId: () => null,
    }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
// Backward-compat alias so existing pages using useDemo() keep working
export const useDemo = useAuth;
